import { render, staticRenderFns } from "./ItemInformacoes.vue?vue&type=template&id=c6955eb2&scoped=true&lang=pug"
import script from "./ItemInformacoes.vue?vue&type=script&lang=js"
export * from "./ItemInformacoes.vue?vue&type=script&lang=js"
import style0 from "./ItemInformacoes.vue?vue&type=style&index=0&id=c6955eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6955eb2",
  null
  
)

export default component.exports